// 우진 (2026-05-07): react-app-polyfill 통째로 제거.
// 1) IE11 은 2022-06 마이크로소프트가 지원 종료 — 그로잉세일즈 사용자 0%.
// 2) main.js .map 분석 결과 react-app-polyfill 이 457KB 원본 (core-js,
//    whatwg-fetch, promise, regenerator-runtime 등) 으로 main bundle 의
//    가장 큰 단일 contributor 였음. 모던 브라우저에서도 prototype patching
//    이 sync 로 실행되어 첫 paint 까지 main thread 점유.
// 3) 결과: main bundle 약 -200KB (532K → ~330K 추정), cold start 첫 페이지
//    paint 까지 sync work 절반 이상 감소 기대.
import React from "react";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

import "./scss/styles.scss";

const MainApp = (
  <Router>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </Router>
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(MainApp);

// Register the public kill-switch SW only for browsers that already have an
// old registration. Fresh visitors should not pay a reload, while stale CRA
// cache-first SW users get forced onto the no-cache pass-through worker.
function cleanupLegacyServiceWorkers() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      if (registrations.length === 0) return;

      const publicUrl = process.env.PUBLIC_URL || "";
      await navigator.serviceWorker.register(`${publicUrl}/service-worker.js`);

      if ("caches" in window) {
        const keys = await window.caches.keys();
        await Promise.all(keys.map((key) => window.caches.delete(key)));
      }
    } catch (error) {
      // Cleanup is best-effort. It must never block the app render path.
    }
  });
}

cleanupLegacyServiceWorkers();
